<div class="checkbox-wrapper">
  <label class="checkbox-container" [class.has-error]="hasError" [class.is-disabled]="disabled">
    <input
      type="checkbox"
      class="checkbox-input"
      [checked]="checked"
      [disabled]="disabled"
      [required]="required"
      [indeterminate]="indeterminate"
      (change)="onCheckboxChange($event)"
      [attr.aria-label]="label"
      [attr.aria-invalid]="hasError"
    />
    <span class="checkbox-label">
      @if (label) {
      <span class="checkbox-text">
        {{ label }}
        @if (required) {
        <span class="required-indicator">*</span>
        }
      </span>
      }
      @if (hint && !hasError) {
      <span class="checkbox-hint">{{ hint }}</span>
      }
    </span>
  </label>

  @if (hasError) {
  <span class="checkbox-error" role="alert">
    {{ errorText }}
  </span>
  }
</div>

